import { motion } from "framer-motion";

const info = [
  {
    name: "PERIOD",
    description: "2023년 1월 ~ 2023년 5월",
  },
  {
    name: "TOOL",
    description: "Procreate, Figma, Expo, ReactNative",
  },
  {
    name: "PERIOD",
    description: "2023년 1월 ~ 2023년 5월",
  },
  {
    name: "TOOL",
    description: "Procreate, Figma, Expo, ReactNative",
  },
];

const imgData = [
  {
    img: "/assets/images/project/ohyoga/d31.png",
    customClass: "top-[10vw] left-[20vw]",
    size: "w-[27vw]",
  },
  {
    img: "/assets/images/project/ohyoga/b02.png",
    customClass: "top-[10vh] left-[10vw]",
    size: "w-[10vw]",
  },
  {
    img: "/assets/images/project/ohyoga/d12.png",
    customClass: "bottom-[20vh] left-[10vw]",
    size: "w-[14vw]",
  },
  {
    img: "/assets/images/project/ohyoga/e07.png",
    customClass: "bottom-[24vh] left-[32vw]",
    size: "w-[14vw]",
  },
];

export default function OhYogaMainBanner(props) {
  return (
    <div className=" bg-amber-50">
      <div className="mx-auto grid min-h-screen max-w-2xl items-center gap-x-8 gap-y-16 px-4 py-24 sm:px-6 sm:py-32 lg:max-w-[1600px] grid-cols-2 lg:px-8">
        <div>
          <img
            className=" w-24 mt-8"
            src="/assets/images/project/ohyoga/logo.png"
            alt="logo"
          />
          <h2
            className="text-[3vw] font-bold tracking-tight text-orange-900 sm:text-4xl "
            data-aos="fade-up"
          ></h2>
          <div
            data-aos="fade-up"
            data-aos-easing="linear"
            data-aos-duration="1000"
          >
            <h2 className="text-[5vw] italic font-bold tracking-tight text-emerald-900">
              {props.lastName}
            </h2>
            <span className="animate-pulse lg:text-[2vw] md:text-[10vw] font-light tracking-tight text-orange-900">
              {props.firstTitle}
            </span>
            <h2 className="text-[5vw] mt-[-3vw] font-bold tracking-tight text-orange-900">
              {props.firstName}
            </h2>
            <p className="mt-20 max-w-[500px] text-gray-500">{props.desc}</p>
          </div>
        </div>
        {imgData.map((index) => (
          <div
            key={index}
            className={`absolute rounded-3xl ${index.customClass}`}
          >
            <motion.div>
              <div className={`absolute rounded-3xl ${index.size}`}>
                <img src={index.img} alt={index.img} />
              </div>
            </motion.div>
          </div>
        ))}
        <div>
          <img
            src={props.img}
            alt="Walnut card tray with white powder coated steel divider and 3 punchout holes."
            data-aos="fade-up"
            data-aos-easing="linear"
            data-aos-duration="1000"
          />
        </div>
      </div>
      <div className=" bg-orange-400">
        <div className="mx-auto grid max-w-2xl grid-cols-1 items-center gap-40 gap-y-16 px-4 py-24 sm:px-6 sm:py-32 lg:max-w-7xl lg:grid-cols-2 lg:px-8">
          <div>
            <h2 className="text-3xl font-bold tracking-tight text-gray-900 sm:text-4xl">
              About Project
            </h2>
            <p className="mt-4 text-gray-500"></p>
            <dl className="mt-16 grid grid-cols-1 gap-x-10 gap-y-10 sm:grid-cols-2 sm:gap-y-16 lg:gap-x-8">
              {info.map((info) => (
                <div key={info.name} className="border-t-2 border-black pt-4">
                  <dt className="font-medium text-gray-900">{info.name}</dt>
                  <dd className="mt-2 text-sm text-black">
                    {info.description}
                  </dd>
                </div>
              ))}
            </dl>
          </div>
          <div className="grid grid-cols-2 grid-rows-2 gap-4 sm:gap-6 lg:gap-8">
            <img
              src="https://tailwindui.com/img/ecommerce-images/product-feature-03-detail-01.jpg"
              alt="Walnut card tray with white powder coated steel divider and 3 punchout holes."
              className="rounded-3xl bg-gray-100"
            />
            <img
              src="https://tailwindui.com/img/ecommerce-images/product-feature-03-detail-02.jpg"
              alt="Top down view of walnut card tray with embedded magnets and card groove."
              className="rounded-3xl bg-gray-100"
            />
            <img
              src="https://tailwindui.com/img/ecommerce-images/product-feature-03-detail-03.jpg"
              alt="Side of walnut card tray with card groove and recessed card area."
              className="rounded-3xl bg-gray-100"
            />
            <img
              src="https://tailwindui.com/img/ecommerce-images/product-feature-03-detail-04.jpg"
              alt="Walnut card tray filled with cards and card angled in dedicated groove."
              className="rounded-3xl bg-gray-100"
            />
          </div>
        </div>
      </div>
    </div>
  );
}
